module.exports = __webpack_public_path__ + "img/rooftop.54f5f7f0.svg";